import React from "react";
import CreateIcon from "@material-ui/icons/Create";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CustomTable from "../../../components/CustomTable";
import ParameterValue from "../../../api/models/test-series/ParameterValue";
import { handleParameterValue } from "../../../validator/ParameterValueValidator";
import NumberParameterValue from "../../../api/models/test-series/NumberParameterValue";

interface SubstrateCharacteristicsTableRow {
  id: number;
  name: string;
  unit: string;
  value: string;
}

interface SubstrateCharacteristicsTableProps {
  parameterValues: ParameterValue[];
  onEdit: (value: ParameterValue) => void;
  onRemove: (value: ParameterValue) => void;
  disabled?: boolean;
}

const formatMaxMinAndValue = (numberValue: NumberParameterValue): string => {
  const { maxValue, minValue, value } = numberValue;
  const minValueString = minValue || minValue === 0 ? `Min: ${minValue}` : "";
  const valueString = value || value === 0 ? `Value: ${value}` : "";
  const maxValueString = maxValue || maxValue === 0 ? `Max: ${maxValue}` : "";
  return [minValueString, valueString, maxValueString].filter((s) => !!s).join(" | ");
};

const SubstrateCharacteristicsTable: React.FunctionComponent<SubstrateCharacteristicsTableProps> = (props) => {
  const { disabled, parameterValues, onEdit, onRemove } = props;
  const generateRows = (): SubstrateCharacteristicsTableRow[] => {
    return parameterValues.map((characteristic, index) => {
      return handleParameterValue(characteristic, {
        number: (numberValue) => ({
          name: numberValue.parameter.name,
          value: formatMaxMinAndValue(numberValue),
          unit: numberValue.unitCode || "",
          id: index,
        }),
        enum: (enumValue) => ({
          name: enumValue.parameter.name,
          value: enumValue.value || "",
          unit: "",
          id: index,
        }),
        text: (textValue) => ({
          name: textValue.parameter.name,
          value: textValue.value || "",
          unit: "",
          id: index,
        }),
      });
    });
  };

  return (
    <CustomTable
      boldIndex={0}
      columns={["Name", "Value", "Unit"]}
      actionColumnIndexes={!disabled ? [0] : undefined}
      excludedKeys={["id"]}
      handleEdit={({ id }) => onEdit(parameterValues[id])}
      rowMenus={!disabled}
      rowMenuActions={
        disabled
          ? undefined
          : [
              {
                action: (rowData): void => onEdit(parameterValues[rowData.id]),
                icon: <CreateIcon />,
                text: "Edit",
              },
              {
                action: (rowData): void => onRemove(parameterValues[rowData.id]),
                icon: <RemoveCircleIcon />,
                text: "Remove",
              },
            ]
      }
      rows={generateRows()}
      selectedItemNameValue="sampleName"
    />
  );
};
export default SubstrateCharacteristicsTable;
